import Vue from 'vue';
import axios from 'axios';

export default {
  name: 'Terms',
  props: ['dataObj'],
  data: function () {
    return {
      termsAndConditions: '',
    }
  },
  created() {
    this.getPortalLicenceAgreement();
    this.$root.$on('lang_changed', this.getPortalLicenceAgreement);
  },
  methods: {
    getPortalLicenceAgreement() {
      if (this && this.$i18n)
        axios.post('/Utility/GetPortalLicenceAgreement', { Value: this.$i18n.locale })
          .then(response => {
            if (response.data.data.status == 0) {
              this.termsAndConditions = response.data.settings.text;
            }
          });
    },
  },
}

